import { useCallback, useEffect, useState } from "react";
import { Info, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import ParentPicker from "./feeReminders/ParentPicker";
import Composer from "./feeReminders/Composer";
import TemplateManager from "./feeReminders/TemplateManager";
import RecentReminders from "./feeReminders/RecentReminders";

/** V192/V197 — WhatsApp Fee Reminders: search parent → reminder type + optional details → open WhatsApp click-to-chat. */
export default function FeeRemindersPanel() {
    const [parent, setParent] = useState(null);
    const [templates, setTemplates] = useState(null);
    const [categories, setCategories] = useState([]);
    const [manage, setManage] = useState(false);
    const [sentKey, setSentKey] = useState(0);
    const load = useCallback(async () => {
        const res = await api.get("/admin/fee-reminders/templates");
        setTemplates(res.data.items || []);
    }, []);
    useEffect(() => { load().catch(() => setTemplates([])); }, [load]);
    useEffect(() => { api.get("/admin/fee-reminders/categories").then(({ data }) => setCategories(data.items || [])).catch(() => {}); }, []);

    return (
        <div className="space-y-5 pb-24 lg:pb-0" data-testid="fee-reminders-panel">
            <header className="flex items-center gap-4 bg-[#0F172A] text-white rounded-2xl p-4 sm:p-5">
                <img src="/logo-anand-tutorials.png" alt="Anand Tutorials" className="h-10 sm:h-12 w-auto bg-white rounded-lg p-1.5" />
                <div className="min-w-0">
                    <h2 className="font-heading text-xl sm:text-2xl font-bold" data-testid="fee-reminders-title">Fee Reminders</h2>
                    <p className="text-sm text-slate-300">Anand Tutorials · Accounts Team — official-style WhatsApp reminders</p>
                </div>
            </header>
            <div className="grid lg:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] gap-5 items-start">
                <div className="space-y-5 min-w-0">
                    <ParentPicker selected={parent} onSelect={setParent} />
                    <RecentReminders parent={parent} refreshKey={sentKey} />
                </div>
                {templates === null ? (
                    <div className="bg-white border border-slate-200 rounded-2xl p-8 grid place-items-center"><Loader2 className="w-5 h-5 animate-spin text-slate-400" /></div>
                ) : (
                    <Composer parent={parent} templates={templates} categories={categories} onManage={() => setManage(true)} onSent={() => setSentKey((k) => k + 1)} />
                )}
            </div>
            <p className="flex items-start gap-2 text-xs text-slate-600 bg-slate-50 border border-slate-200 rounded-xl p-3" data-testid="fee-waba-note">
                <Info className="w-4 h-4 shrink-0 mt-0.5 text-[#1E3A8A]" />
                <span>Messages go out from whichever WhatsApp account is logged in on this device. The Anand Tutorials name in the message is a signature, not a verified badge. To send from a single verified Anand Tutorials business number, the official WhatsApp Business Platform can be set up later as a separate, optional step. Reminders work fully without it.</span>
            </p>
            {templates && <TemplateManager open={manage} onOpenChange={setManage} templates={templates} categories={categories} onChanged={load} />}
        </div>
    );
}
